/**
 * Links in a task's details: a QC review task names its asset's QC tab as an in-app path ("/assets/<id>?tab=qc"),
 * and people paste web addresses. Splits the text into plain parts and links so read-only details can show them clickable.
 */
export type DetailPart = { text: string; to?: string; href?: string };

// An in-app path (after the start, a space or an opening bracket) or an http(s) address; trailing punctuation stays text.
const LINK = /(^|[\s(])(\/(?:assets|create|collections|tasks|library)\/[^\s)]*[^\s).,;:!?]|https?:\/\/[^\s)]*[^\s).,;:!?])/g;

export function detailParts(text: string): DetailPart[] {
  const parts: DetailPart[] = [];
  let last = 0;
  for (const m of text.matchAll(LINK)) {
    const lead = m[1] ?? '';
    const link = m[2] ?? '';
    const start = m.index + lead.length;
    if (start > last) parts.push({ text: text.slice(last, start) });
    parts.push(link.startsWith('/') ? { text: link, to: link } : { text: link, href: link });
    last = start + link.length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
}
